import '@loyal_template/loading.css'
import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import LoadCartaoCash from '@loyal_images/load-cartao.png'
import LoadCartaoCashMob from '@loyal_images/load-cartao-mob.png'
import LoadingAnimate from '@loyal_images/loading-animate.gif'

class RedirectCashStyle extends Component {
  render () {
    return (
      <div className='row mx-0 loading-screen screen-default'>
        <div className='col-12 bg-brand-4 progress-loader p-0'>
          <div className='progress-bar' />
        </div>
        <div className='col-12 bg-brand-2 txt-loading bg-loading-write py-5 d-flex align-items-center justify-content-center'>
          <div>
            <MediaQuery minDeviceWidth={500}>
              <div className='d-flex align-items-center justify-content-center'>
                <img src={LoadCartaoCash} />
              </div>
            </MediaQuery>
            <MediaQuery maxDeviceWidth={425}>
              <div className='d-flex align-items-center justify-content-center'>
                <img src={LoadCartaoCashMob} />
              </div>
            </MediaQuery>
            <div className='d-flex align-items-center justify-content-center'>
              <img src={LoadingAnimate} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RedirectCashStyle



// WEBPACK FOOTER //
// ./src/App/MainMenu/OnlyCash/RedirectCashStyle.js